import { RECEIVE_PAYMENTFORM, REQUEST_PAYMENTFORM } from '../actions/a.payment-form'

import Store from '../store'

const PaymentForm = (state = Store.PaymentForm, action) => {
    switch(action.type) {
        case REQUEST_PAYMENTFORM:
            return {
                ...state,
                isFetching: true,
            }
        case RECEIVE_PAYMENTFORM:
            return {
                ...state,
                isFetching: false,
            }
        default:
            return state
    }
} 

export default PaymentForm